import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Flatpickr from 'react-flatpickr';
import moment from 'moment';
import { Link } from 'react-router-dom';
import * as appConstants from '../../constants/ApplicationConstants';
import * as validationTypes from '../../constants/ValidationConstants';
import '../../../node_modules/flatpickr/dist/themes/material_blue.css';
import '../../common/webar_flatpickr.css';
import {
    getDefaultFilters, getImpersonatedUserId,
    getPayerSoldToForInvoiceQuery,
    getSelectedPrimaryAccount,
    getSelectedSecondaryAccount
} from "./Selectors";
import { getInvoicesAjax, getInvoiceSearchPDF } from "../../actions/InvoiceActions";
import { InvoiceSearchList } from "./InvoiceList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faCalendarAlt, faChevronDown, faTimes } from "@fortawesome/free-solid-svg-icons";
import { updateInvoiceListQuery } from "../../actions/InvoiceActions";

class InvoiceSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            invoices: [],
            searched: false,
            status: '03',
            dueDateFrom: '',
            dueDateTo: '',
            period: '30',
            dateFrom: '',
            dateTo: '',
            characteristics: '',
            characteristicsValue: '',
            characteristicsLabel: '',
            showDatesDue: false,
            showPeriod: true,
            showDatesPeriod: false,
            showCharacteristicsValue: false,
        };
        this.onDateChange = this.onDateChange.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.onFindClick = this.onFindClick.bind(this);
        this.exportToPdf = this.exportToPdf.bind(this);
        this.getSearch = this.getSearch.bind(this);
    }

    componentDidMount() {
    }

    static getDerivedStateFromProps(props, state) {
        if (props.primaryAccountIndex !== state.currentPrimaryAccountIndex) {
            return {
                ...state,
                currentPrimaryAccountIndex: props.primaryAccountIndex,
                invoices: [],
                searched: false,
            }
        }
        return { ...state };
    }


    onDateChange(selectedDates, dateStr, instance) {
        let from = '';
        let to = '';
        if (selectedDates && selectedDates.length > 0) {
            from = selectedDates[0] && selectedDates[1] ? moment(selectedDates[0]).format('MM-DD-YYYY') : '';
            to = selectedDates[0] && selectedDates[1] ? moment(selectedDates[1]).format('MM-DD-YYYY') : '';
        }
        const controlId = instance.input.id;
        switch (controlId) {
            case 'datesDue':
                this.setState({ dueDateFrom: from, dueDateTo: to });
                break;
            case 'datesPeriod':
                this.setState({ dateFrom: from, dateTo: to });
                break;
            default:
                break;
        }
    }

    onSelectChange(name, e) {
        let option = e.target.value;
        switch (name) {
            case 'status':
                this.setState({
                    status: option,
                    showDatesDue: option && option === '01',
                    showPeriod: option && option !== '01'
                });
                break;
            case 'period':
                this.setState({
                    period: option,
                    showDatesPeriod: option && option === '-1',
                });
                break;
            case 'characteristics':
                this.setState({
                    characteristics: option ? option : '',
                    showCharacteristicsValue: option && option,
                    characteristicsLabel: option ? e.target.options[e.target.selectedIndex].text : '',
                });
                break;
            default:
                break;
        }
    }

    onCharacteristicsValueChange = (e) => {
        this.setState({ characteristicsValue: e.target.value });
    };

    getSearch() {
        let {
            dueDateFrom, dueDateTo, dateFrom, dateTo,
        } = this.state;
        const {
            status, period, characteristics, characteristicsValue,
        } = this.state;
        let datesRequired = false;
        let filterValueRequired = false;
        if (status === '01') {
            dateFrom = appConstants.INV_LIST_REQ_BEGIN_DATE;
            dateTo = appConstants.INV_LIST_REQ_END_DATE;
            if (!dueDateFrom || !dueDateTo) {
                toast.warn(validationTypes.DUE_DATES_REQUIRED, { position: toast.POSITION.TOP_RIGHT });
                datesRequired = true;
            }
        } else {
            dueDateFrom = '';
            dueDateTo = '';
        }
        if (period === '-1') {
            if (!dateFrom || !dateTo) {
                toast.warn(validationTypes.DOCUMENT_DATES_REQUIRED, { position: toast.POSITION.TOP_RIGHT });
                datesRequired = true;
            }
        } else {
            dateFrom = this.getDateFrom(period);
            dateTo = moment(new Date()).format('MM-DD-YYYY');
        }
        const filters = [];
        if (characteristics) {
            if (!characteristicsValue) {
                toast.warn(validationTypes.CHARACTERISTICS_VALUE_REQUIRED, { position: toast.POSITION.TOP_RIGHT });
                filterValueRequired = true;
            } else {
                const filter = { filter_type: characteristics, value: characteristicsValue };
                filters.push(filter);
            }
        }
       

        let { payer_data, soldto_data } = getPayerSoldToForInvoiceQuery(this.props.accountType, this.props.secondaryAccount, this.props.primaryAccount);
        let search = {
            payer_data,
            soldto_data,
            search_parameters: {
                document_type: '01',
                status: status,
                date_from: dateFrom,
                date_to: dateTo,
                due_date_from: dueDateFrom,
                due_date_to: dueDateTo,
                currency_key: '',
                filter: getDefaultFilters(this.props.accountType, this.props.impersonatedUserId).concat(filters),
            }
        };
        if (!datesRequired && !filterValueRequired) {
            //InvoiceListRequest
            updateInvoiceListQuery(this.props.dispatch, search);
        }

        return search;
    }

    exportToPdf() {
        try {
            let search = this.getSearch();
            getInvoiceSearchPDF(this.props.dispatch, search);
        } catch (e) {
            return null;
        }

    }

    onFindClick() {
        try {
            let search = this.getSearch();
            getInvoicesAjax(search).then((response) => {
                this.setState({ invoices: response.data.document_list, searched: true });
            });
        } catch (e) {
            return null;
        }

        // let searchQuery =  {
        //   payer_data,
        //   soldto_data,
        //   search_parameters: {
        //     document_type: '01',
        //     status: status,
        //     date_from: fromDate ? fromDate : appConstants.INV_LIST_REQ_BEGIN_DATE,
        //     date_to: toDate ? toDate : moment(new Date()).format('MM-DD-YYYY'),
        //     due_date_from: dueDateFrom,
        //     due_date_to: dueDateTo,
        //     currency_key: '',
        //     filter: tempFilter,
        //   }
        // };
    }

    getDateFrom = (days) => {
        const date = new Date();
        date.setDate(date.getDate() - days);
        return moment(date).format('MM-DD-YYYY');
    }

    render() {
        const countOfInvoices = this.state.invoices ? this.state.invoices.length : 0;
        return (
            <div className="container">
                <div className="card">
                    <div className="card-body nopadding">
                        <div className="row">
                            <div className="col-lg-11 col-md-11 col-sm-11 col-11">
                                <h3 className="invoiceSearch col-form-label col-form-label-sm text-secondary">Invoice Search</h3>
                            </div>
                            <div className="col-lg-1 col-md-1 col-sm-1 col-1 nopadding">
                                <span>
                                    <Link to="/invoices">
                                        <FontAwesomeIcon icon={faTimes} className={"text-secondary float-right"} />
                                    </Link>
                                </span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-2 col-md-4 col-sm-4 col-4 bottompadding">
                                <span className="float-right col-form-label col-form-label-sm text-secondary">Status</span>
                            </div>
                            <div className="col-lg-4 col-md-8 col-sm-8 col-8 bottompadding customSelect">
                                <select
                                    name="status"
                                    className="form-control"
                                    onChange={this.onSelectChange.bind(this, 'status')}>
                                    {this.props.invoiceStatusOptions.map(status => {
                                        return (
                                            <option value={status.value} key={status.value}>
                                                {status.label}
                                            </option>
                                        )
                                    })}
                                </select>
                                <FontAwesomeIcon icon={faChevronDown} className={"select-arrow"} />
                            </div>
                            <div
                                className={`${'col-lg-2 col-md-4 col-sm-4 col-4 bottompadding'}${' '} ${this.state.showDatesDue ? '' : 'hideControl'}`}>
                                <span className="float-right col-form-label col-form-label-sm text-secondary">Due</span>
                            </div>
                            <div
                                className={`${'col-lg-4 col-md-8 col-sm-8 col-8 bottompadding'}${' '} ${this.state.showDatesDue ? '' : 'hideControl'}`}>
                                <FontAwesomeIcon icon={faCalendar} className={"calendarPosition"} />
                                <Flatpickr
                                    className="inp form-control"
                                    id="datesDue"
                                    value={[this.state.dueDateFrom, this.state.dueDateTo]}
                                    onClose={this.onDateChange}
                                    options={{
                                        mode: 'range',
                                        dateFormat: 'm-d-Y',
                                        minDate: new Date(new Date().setDate(new Date().getDate() - 365)),
                                        maxDate: new Date(new Date().setDate(new Date().getDate() + 365)),
                                    }}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div
                                className={`${'col-lg-2 col-md-4 col-sm-4 col-4 float-right bottompadding'}${' '}${this.state.showPeriod ? '' : 'hideControl'}`}>
                                <span className="float-right col-form-label col-form-label-sm text-secondary">Period</span>
                            </div>
                            <div
                                className={`${'col-lg-4 col-md-8 col-sm-8 col-8 bottompadding customSelect'}${' '}${this.state.showPeriod ? '' : 'hideControl'}`}>
                                <select
                                    name="period"
                                    className="form-control"
                                    value={this.state.period}
                                    onChange={this.onSelectChange.bind(this, 'period')}>
                                    {this.props.periodOptions.map(period => {
                                        return (
                                            <option value={period.value} key={period.value}>
                                                {period.label}
                                            </option>
                                        )
                                    })}
                                </select>
                                <FontAwesomeIcon icon={faChevronDown} className={"select-arrow"} />
                            </div>
                            <div
                                className={`${'col-lg-2 col-md-4 col-sm-4 col-4 bottompadding'}${' '}${this.state.showPeriod && this.state.showDatesPeriod ? '' : 'hideControl'}`}>
                                <span className="float-right col-form-label col-form-label-sm text-secondary">From</span>
                            </div>
                            <div
                                className={`${'col-lg-4 col-md-8 col-sm-8 col-8 bottompadding'}${' '}${this.state.showPeriod && this.state.showDatesPeriod ? '' : 'hideControl'}`}>
                                <FontAwesomeIcon icon={faCalendar} className={"calendarPosition"} />
                                <Flatpickr
                                    className="inp form-control"
                                    id="datesPeriod"
                                    value={[this.state.dateFrom, this.state.dateTo]}
                                    onClose={this.onDateChange}
                                    options={{
                                        mode: 'range',
                                        dateFormat: 'm-d-Y',
                                        minDate: new Date(new Date().setDate(new Date().getDate() - 365)),
                                        maxDate: new Date(new Date().setDate(new Date().getDate() + 365)),
                                    }}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-2 col-md-4 col-sm-4 col-4 bottompadding">
                                <span className="float-right col-form-label col-form-label-sm text-secondary">Search Options</span>
                            </div>
                            <div className="col-lg-4 col-md-8 col-sm-8 col-8 bottompadding customSelect">
                                <select
                                    name="status"
                                    className="form-control"
                                    onChange={this.onSelectChange.bind(this, 'characteristics')}>
                                    <option selected="selected" value="">Choose Feature</option>
                                    {this.props.characteristicsOptions.map(characterstic => {
                                        return (
                                            <option value={characterstic.value} key={characterstic.value}>
                                                {characterstic.label}
                                            </option>
                                        )
                                    })}
                                </select>
                                <FontAwesomeIcon icon={faChevronDown} className={"select-arrow"} />
                            </div>
                            <div className="col-lg-2 col-md-4 col-sm-4 col-4 bottompadding">
                                <span className="float-right col-form-label col-form-label-sm text-secondary">
                                    &nbsp;
                                </span>
                            </div>
                            <div
                                className={`${'col-lg-4 col-md-8 col-sm-8 col-8 bottompadding'}${' '}${this.state.showCharacteristicsValue ? '' : 'hideControl'}`}>
                                <input type="text" className="form-control control-border" placeholder={this.state.characteristicsLabel}
                                    value={this.state.characteristicsValue} name="invNumbner"
                                    onChange={this.onCharacteristicsValueChange}
                                    maxLength={10}
                                />
                            </div>
                        </div>
                        <div className="form-row text-center mt-4">
                            <div className="col-12">
                                <button type="button"
                                    className="btn btn-primary findButtonColor form-control control-border button-class"
                                    onClick={this.onFindClick}>Find
                                </button>
                            </div>
                        </div>

                        <br />
                    </div>
                </div>
                {this.state.invoices && this.state.invoices.length > 0 && <div className="row mt-2">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 justify-content-end d-flex">
                        <button type="button"
                            className="btn btn-primary btn-sm"
                            onClick={this.exportToPdf}>Export to PDF
                        </button>
                    </div>
                </div>
                }
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <span className="invoiceSearch col-form-label col-form-label-sm text-secondary float-right">
                            {this.props.searched && <span>{countOfInvoices} Invoices found!</span>}
                        </span>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <InvoiceSearchList invoices={this.state.invoices} isSearch={true} />
                    </div>
                </div>
                <br />
                <br />
                <br />
                <br />
            </div>
        );
    }
}

InvoiceSearch.propTypes = {
    dispatch: PropTypes.func.isRequired,
};

export default connect((store, props) => ({
    accountType: store.user_options.accountType,
    primaryAccount: getSelectedPrimaryAccount(store, props),
    primaryAccountIndex: store.user_options.selectedPrimaryAccountIndex,//getSelectedPrimaryAccountIndex(store, props),
    secondaryAccount: getSelectedSecondaryAccount(store, props),
    invoiceStatusOptions: store.default.invoiceStatusOptions,
    periodOptions: store.default.periodOptions,
    characteristicsOptions: store.default.characteristicsOptions,
    filter: store.user_options.filter,
    impersonatedUserId: getImpersonatedUserId(store, props),
}), null, null, { pure: false })(InvoiceSearch);
